
import { test } from './test'
export const calculation = {
  mixins: [test],
  data () {
    return {}
  },
  methods: {
    // ==========================================================
    obliczenia_sprzetowe (fileOpen = null) {
      console.log('----- obliczenia_sprzetowe -----')
      // eslint-disable-next-line
      var C1Devices = this.getAttributesDevice(this.clusterOne)
      var C2Devices = this.getAttributesDevice(this.clusterTwo)
      var C3Devices = this.getAttributesDevice(this.clusterThree)
      var C4Devices = this.getAttributesDevice(this.clusterFour)
      var C5Devices = this.getAttributesDevice(this.clusterFive)
      var C6Devices = this.getAttributesDevice(this.clusterSix)
      // console.log('== C1Devices ==')
      // console.log(C1Devices)

      this.$store.commit('app/UPDATE_CLUSTERS_SELECTED',
        { 'cluster1': C1Devices, 'cluster2': C2Devices, 'cluster3': C3Devices, 'cluster4': C4Devices, 'cluster5': C5Devices, 'cluster6': C6Devices })

      // eslint-disable-next-line
      var C1DeviceBatteryCurrent = this.setDevicesCurrent(C1Devices, this.clusterOne)
      var C2DeviceBatteryCurrent = this.setDevicesCurrent(C2Devices, this.clusterTwo)
      var C3DeviceBatteryCurrent = this.setDevicesCurrent(C3Devices, this.clusterThree)
      var C4DeviceBatteryCurrent = this.setDevicesCurrent(C4Devices, this.clusterFour)
      var C5DeviceBatteryCurrent = this.setDevicesCurrent(C5Devices, this.clusterFive)
      var C6DeviceBatteryCurrent = this.setDevicesCurrent(C6Devices, this.clusterSix)
      // console.log('== C1DeviceBatteryCurrent ==')
      // console.log(C1DeviceBatteryCurrent)

      // eslint-disable-next-line
      var C1TotalQuantity = this.setTotalDevicesQuantity(C1DeviceBatteryCurrent)
      // eslint-disable-next-line
      var C2TotalQuantity = this.setTotalDevicesQuantity(C2DeviceBatteryCurrent)
      // eslint-disable-next-line
      var C3TotalQuantity = this.setTotalDevicesQuantity(C3DeviceBatteryCurrent)
      // eslint-disable-next-line
      var C4TotalQuantity = this.setTotalDevicesQuantity(C4DeviceBatteryCurrent)
      // eslint-disable-next-line
      var C5TotalQuantity = this.setTotalDevicesQuantity(C5DeviceBatteryCurrent)
      // eslint-disable-next-line
      var C6TotalQuantity = this.setTotalDevicesQuantity(C6DeviceBatteryCurrent)
      // console.log('== TotalQuantity ==')
      // console.log(TotalQuantity)

      // eslint-disable-next-line
      var C1TotalCurrent = this.setTotalDevicesCurrent(C1DeviceBatteryCurrent)
      var C2TotalCurrent = this.setTotalDevicesCurrent(C2DeviceBatteryCurrent)
      var C3TotalCurrent = this.setTotalDevicesCurrent(C3DeviceBatteryCurrent)
      var C4TotalCurrent = this.setTotalDevicesCurrent(C4DeviceBatteryCurrent)
      var C5TotalCurrent = this.setTotalDevicesCurrent(C5DeviceBatteryCurrent)
      var C6TotalCurrent = this.setTotalDevicesCurrent(C6DeviceBatteryCurrent)
      // console.log('== TotalCurrent ==')
      // console.log(C1TotalCurrent)

      // eslint-disable-next-line
      var C1DeviceBatteryCapacity = this.setDevicesCapacity(C1DeviceBatteryCurrent)
      var C2DeviceBatteryCapacity = this.setDevicesCapacity(C2DeviceBatteryCurrent)
      var C3DeviceBatteryCapacity = this.setDevicesCapacity(C3DeviceBatteryCurrent)
      var C4DeviceBatteryCapacity = this.setDevicesCapacity(C4DeviceBatteryCurrent)
      var C5DeviceBatteryCapacity = this.setDevicesCapacity(C5DeviceBatteryCurrent)
      var C6DeviceBatteryCapacity = this.setDevicesCapacity(C6DeviceBatteryCurrent)
      // console.log('== C1DeviceBatteryCapacity ==')
      // console.log(C1DeviceBatteryCapacity)

      // eslint-disable-next-line
      var C1Results = this.setDevicesResults(C1DeviceBatteryCapacity, C1TotalCurrent)
      var C2Results = this.setDevicesResults(C2DeviceBatteryCapacity, C2TotalCurrent)
      var C3Results = this.setDevicesResults(C3DeviceBatteryCapacity, C3TotalCurrent)
      var C4Results = this.setDevicesResults(C4DeviceBatteryCapacity, C4TotalCurrent)
      var C5Results = this.setDevicesResults(C5DeviceBatteryCapacity, C5TotalCurrent)
      var C6Results = this.setDevicesResults(C6DeviceBatteryCapacity, C6TotalCurrent)
      // console.log('== C1Results ==')
      // console.log(C1Results)

      this.changeValueOutputs('resultDevices', 'array', { 'c1': C1Results, 'c2': C2Results, 'c3': C3Results, 'c4': C4Results, 'c5': C5Results, 'c6': C6Results })

      this.changeValueOutputs('akumulators', 'array',
        {
          'c1': (this.outputs.akumulator_user.c1) ? this.outputs.akumulators.c1 : this.checkBatteries(Math.ceil(C1Results.required)),
          'c2': (this.outputs.akumulator_user.c2) ? this.outputs.akumulators.c2 : this.checkBatteries(Math.ceil(C2Results.required)),
          'c3': (this.outputs.akumulator_user.c3) ? this.outputs.akumulators.c3 : this.checkBatteries(Math.ceil(C3Results.required)),
          'c4': (this.outputs.akumulator_user.c4) ? this.outputs.akumulators.c4 : this.checkBatteries(Math.ceil(C4Results.required)),
          'c5': (this.outputs.akumulator_user.c5) ? this.outputs.akumulators.c5 : this.checkBatteries(Math.ceil(C5Results.required)),
          'c6': (this.outputs.akumulator_user.c6) ? this.outputs.akumulators.c6 : this.checkBatteries(Math.ceil(C6Results.required))
        }
      )

      this.changeValueOutputs('akumulators_buffor', 'array',
        {
          'c1': this.checkBatteries(Math.ceil(C1Results.required)),
          'c2': this.checkBatteries(Math.ceil(C2Results.required)),
          'c3': this.checkBatteries(Math.ceil(C3Results.required)),
          'c4': this.checkBatteries(Math.ceil(C4Results.required)),
          'c5': this.checkBatteries(Math.ceil(C5Results.required)),
          'c6': this.checkBatteries(Math.ceil(C6Results.required))
        }
      )

      this.changeValueOutputs('mozliwe_akumulatory', 'array',
        {
          'c1': this.checkBatteriesMore(Math.ceil(C1Results.required)),
          'c2': this.checkBatteriesMore(Math.ceil(C2Results.required)),
          'c3': this.checkBatteriesMore(Math.ceil(C3Results.required)),
          'c4': this.checkBatteriesMore(Math.ceil(C4Results.required)),
          'c5': this.checkBatteriesMore(Math.ceil(C5Results.required)),
          'c6': this.checkBatteriesMore(Math.ceil(C6Results.required))
        }
      )

      // eslint-disable-next-line
      var TotalLoss = this.getTotalLoss([C1DeviceBatteryCurrent, C2DeviceBatteryCurrent, C3DeviceBatteryCurrent, C4DeviceBatteryCurrent, C5DeviceBatteryCurrent, C6DeviceBatteryCurrent])

      var countShelfs = this.checkBatteriesShelfs(this.inputs.glebokosc_szafy.value)
      // console.log('countShelfs: ', countShelfs)

      // var heightDevices = this.getDevicesHeight([C1Devices, C2Devices, C3Devices, C4Devices, C5Devices, C6Devices], countShelfs)
      var heightDevices = this.getDevicesHeight([C1Devices, C2Devices, C3Devices, C4Devices, C5Devices, C6Devices], countShelfs)
      // console.log('heightDevices', heightDevices)

      var heightDevicesPlus = this.getDevicesHeightPlus(this.inputs.panel_wentylacyjny.value, this.inputs.polka_mikrofon.value, this.inputs.dodatkowe_u.value)
      // console.log('heightDevicesPlus', heightDevicesPlus)

      var heightDevicesTest = this.getDevicesHeight([C1Devices, C2Devices, C3Devices, C4Devices, C5Devices, C6Devices], 0)
      // console.log('heightDevices', heightDevices)

      var totalHeightDevices = { wysokosc: (heightDevices.wysokosc + heightDevicesPlus.wysokosc), oczka: (heightDevices.oczka + heightDevicesPlus.oczka) }
      // console.log('totalHeightDevices', totalHeightDevices)

      this.changeValueOutputs('szafa_zajete_miejsce', 'value', totalHeightDevices.oczka)

      // console.log(heightDevicesTest, heightDevicesPlus)

      // console.log('glebokosc_szafy: ', this.inputs.glebokosc_szafy)

      if (!this.inputs.glebokosc_szafy.active) {
        // this.changeRackCabinets(totalHeightDevices.oczka)
        this.testGetRack(heightDevicesTest, heightDevicesPlus)
      } else {
        if (totalHeightDevices.oczka > (Number(this.outputs.szafa.attributes.wysokosc) * 3)) {
          this.changeValueInputs('glebokosc_szafy', 'active', false)
          this.testGetRack(heightDevicesTest, heightDevicesPlus)
          // this.changeRackCabinets(totalHeightDevices.oczka)
        } else {
          var wolneMiejsce = (this.outputs.szafa.attributes.wysokosc * 3) - Number(totalHeightDevices.oczka)
          this.changeValueOutputs('szafa_wolne_miejsce', 'value', Number(wolneMiejsce))
        }
      }

      // console.log(this.outputs.szafa_wolne_miejsce.value)

      var iloscGrup = this.setQulityClusters(this.outputs.akumulators)
      // console.log('iloscGrup: ', iloscGrup)
      this.setListwy(iloscGrup)

      var ceny = this.getPriceDeviceStatic(this.outputs.szafa, this.outputs.akumulators)
      var waga = this.getWeightDeviceStatic(this.outputs.szafa, this.outputs.akumulators)

      this.changeValuePrice('szafa', ceny.szafa)
      this.changeValuePrice('akumulatory', ceny.akumulatory)
      this.changeValuePrice('panelS', Number(this.getPriceDevice('PSG3LA', 'panelS')))

      this.changeValueWeight('szafa', waga.szafa)
      this.changeValueWeight('akumulatory', waga.akumulatory)
      this.changeValueWeight('panelS', Number(this.getWeightDevice('PSG3LA')))

      var materialy = this.dodanie_materialow()
      this.changeValuePrice('inne', materialy.cena)
      this.changeValueWeight('inne', materialy.waga)
      // console.log(materialy)

      if (this.inputs.panel_wentylacyjny.value === 1 || this.inputs.panel_wentylacyjny.value === '1') {
        var cenaWentylator = 0
        var wagaWentylator = 0
        var deviceZaslepka = this.ListaPulsar.filter(item => item.kod === 'RAPZ1')
        this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zaslepka', 'value': deviceZaslepka[0]})
        var cenaZaslepka = deviceZaslepka[0].attributes.cena
        var wagaZaslepka = deviceZaslepka[0].attributes.waga
        var device600 = this.ListaPulsar.filter(item => item.kod === 'RAWP600RZ')
        this.$store.commit('products/SET_LIST_SELECTED', {'key': 'panelW', 'value': device600[0]})
        cenaWentylator = Number(device600[0].attributes.cena)
        wagaWentylator = Number(device600[0].attributes.waga)
        this.changeValuePrice('panelW', (Number(cenaWentylator) + Number(cenaZaslepka)))
        this.changeValueWeight('panelW', (Number(wagaWentylator) + Number(wagaZaslepka)))
      }

      if (fileOpen) {
        this.changeOther('wariant2', this.inputs.wariant2.value)
        this.changeOther('wariant3', this.inputs.wariant3.value)
        this.changeOther('kolka', this.inputs.kolka.value)
        this.changeOther('polka_mikrofon', this.inputs.polka_mikrofon.value)
        this.changeOther('obudowa_plytki', this.inputs.obudowa_plytki.value)

        // var cenaWentylator = 0
        // var wagaWentylator = 0
        // var deviceZaslepka = this.ListaPulsar.filter(item => item.kod === 'RAPZ1')
        // var cenaZaslepka = deviceZaslepka[0].attributes.cena
        // var wagaZaslepka = deviceZaslepka[0].attributes.waga
        // var device600 = this.ListaPulsar.filter(item => item.kod === 'RAWP600RZ')
        // cenaWentylator = Number(device600[0].attributes.cena)
        // wagaWentylator = Number(device600[0].attributes.waga)
        // this.changeValuePrice('panelW', (Number(cenaWentylator) + Number(cenaZaslepka)))
        // this.changeValueWeight('panelW', (Number(wagaWentylator) + Number(wagaZaslepka)))
      }

      this.configuration_keygen()

      this.zapiszRuch()
    },
    setDevicesCurrent (clusterSelected, clusterInputs) {
      var arrayDevice = []
      var iloscAD604 = 0
      var iloscAD608 = 0
      var iloscAD604ethernet = 0
      var iloscAD604loudspeaker = 0
      var iloscAD608ethernet = 0
      var iloscAD608loudspeaker = 0
      var iloscES8P2S = 0
      var iloscES8P2Sethernet = 0
      var iloscES8P2Ssfp = 0
      var iloscES8P2Spoe = 0

      Object.keys(clusterSelected).forEach(element => {
        if (clusterSelected[element].kod === 'PRA-MPS3') {
          arrayDevice[clusterSelected[element].kod] = []
          arrayDevice[clusterSelected[element].kod] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterSelected[element].current.quiescent),
                'alarm': Number(clusterSelected[element].current.alarm)
              },
              'total': {
                'quiescent': 1 * Number(clusterSelected[element].current.quiescent),
                'alarm': 1 * Number(clusterSelected[element].current.alarm)
              }
            },
            'ethernet': {
              'quantity': Number(clusterInputs['powerSupply']['ethernet']),
              'single': {
                'quiescent': Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterSelected[element].ethernet.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs['powerSupply']['ethernet']) * Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterInputs['powerSupply']['ethernet']) * Number(clusterSelected[element].ethernet.alarm)
              }
            },
            'sfp': {
              'quantity': Number(clusterInputs['powerSupply']['sfp']),
              'single': {
                'quiescent': Number(clusterSelected[element].sfp.quiescent),
                'alarm': Number(clusterSelected[element].sfp.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs['powerSupply']['sfp']) * Number(clusterSelected[element].sfp.quiescent),
                'alarm': Number(clusterInputs['powerSupply']['sfp']) * Number(clusterSelected[element].sfp.alarm)
              }
            }
          }
        }
        if (element === 'output24' && clusterSelected[element].kod === 'PRA-SCL') {
          arrayDevice[clusterSelected[element].kod] = []
          arrayDevice[clusterSelected[element].kod] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterSelected[element].current.quiescent),
                'alarm': Number(clusterSelected[element].current.alarm)
              },
              'total': {
                'quiescent': 1 * Number(clusterSelected[element].current.quiescent),
                'alarm': 1 * Number(clusterSelected[element].current.alarm)
              }
            },
            'ethernet': {
              'quantity': Number(clusterInputs['output24']['ethernet']),
              'single': {
                'quiescent': Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterSelected[element].ethernet.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs['output24']['ethernet']) * Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterInputs['output24']['ethernet']) * Number(clusterSelected[element].ethernet.alarm)
              }
            }
          }
        }
        if (clusterSelected[element].kod === 'PRA-AD604') {
          ++iloscAD604
          iloscAD604ethernet += Number(clusterInputs[element]['ethernet'])
          iloscAD604loudspeaker += Number(clusterInputs[element]['loudspeaker'])
          arrayDevice[clusterSelected[element].kod] = {
            'current': {
              'quantity': iloscAD604,
              'single': {
                'quiescent': Number(clusterSelected[element].current.quiescent)
              },
              'total': {
                'quiescent': iloscAD604 * Number(clusterSelected[element].current.quiescent),
                'alarm': ((((20.83 - 5.33) / 600) * iloscAD604loudspeaker) + (5.33 * iloscAD604)) * 1000
              }
            },
            'ethernet': {
              'quantity': iloscAD604ethernet,
              'single': {
                'quiescent': Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterSelected[element].ethernet.alarm)
              },
              'total': {
                'quiescent': iloscAD604ethernet * Number(clusterSelected[element].ethernet.quiescent),
                'alarm': iloscAD604ethernet * Number(clusterSelected[element].ethernet.alarm)
              }
            },
            'loudspeaker': {
              'quantity': iloscAD604loudspeaker
            }
          }
        }
        if (clusterSelected[element].kod === 'PRA-AD608') {
          ++iloscAD608
          iloscAD608ethernet += Number(clusterInputs[element]['ethernet'])
          iloscAD608loudspeaker += Number(clusterInputs[element]['loudspeaker'])
          arrayDevice[clusterSelected[element].kod] = {
            'current': {
              'quantity': iloscAD608,
              'single': {
                'quiescent': Number(clusterSelected[element].current.quiescent)
              },
              'total': {
                'quiescent': iloscAD608 * Number(clusterSelected[element].current.quiescent),
                'alarm': ((((22.83 - 7.33) / 600) * iloscAD608loudspeaker) + (7.33 * iloscAD608)) * 1000
              }
            },
            'ethernet': {
              'quantity': iloscAD608ethernet,
              'single': {
                'quiescent': Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterSelected[element].ethernet.alarm)
              },
              'total': {
                'quiescent': iloscAD608ethernet * Number(clusterSelected[element].ethernet.quiescent),
                'alarm': iloscAD608ethernet * Number(clusterSelected[element].ethernet.alarm)
              }
            },
            'loudspeaker': {
              'quantity': iloscAD608loudspeaker
            }
          }
        }
        if (clusterSelected[element].kod === 'PRA-ES8P2S') {
          ++iloscES8P2S
          iloscES8P2Sethernet += Number(clusterInputs[element]['ethernet'])
          iloscES8P2Ssfp += Number(clusterInputs[element]['sfp'])
          iloscES8P2Spoe += Number(clusterInputs[element]['poe'])
          arrayDevice[clusterSelected[element].kod] = {
            'current': {
              'quantity': iloscES8P2S,
              'single': {
                'quiescent': Number(clusterSelected[element].current.quiescent),
                'alarm': Number(clusterSelected[element].current.alarm)
              },
              'total': {
                'quiescent': iloscES8P2S * Number(clusterSelected[element].current.quiescent),
                'alarm': iloscES8P2S * Number(clusterSelected[element].current.alarm)
              }
            },
            'ethernet': {
              'quantity': iloscES8P2Sethernet,
              'single': {
                'quiescent': Number(clusterSelected[element].ethernet.quiescent),
                'alarm': Number(clusterSelected[element].ethernet.alarm)
              },
              'total': {
                'quiescent': iloscES8P2Sethernet * Number(clusterSelected[element].ethernet.quiescent),
                'alarm': iloscES8P2Sethernet * Number(clusterSelected[element].ethernet.alarm)
              }
            },
            'sfp': {
              'quantity': iloscES8P2Ssfp,
              'single': {
                'quiescent': Number(clusterSelected[element].sfp.quiescent),
                'alarm': Number(clusterSelected[element].sfp.alarm)
              },
              'total': {
                'quiescent': iloscES8P2Ssfp * Number(clusterSelected[element].sfp.quiescent),
                'alarm': iloscES8P2Ssfp * Number(clusterSelected[element].sfp.alarm)
              }
            },
            'poe': {
              'quantity': iloscES8P2Spoe,
              'total': {
                'quiescent': (iloscES8P2Spoe / 12) * 1000,
                'alarm': (iloscES8P2Spoe / 12) * 1000
              }
            }
          }
        }
        if (element === 'output24' && clusterSelected[element].kod === 'other') {
          arrayDevice[clusterSelected[element].kod + '24'] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterInputs[element].maxCurrent),
                'alarm': Number(clusterInputs[element].maxCurrent)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].maxCurrent),
                'alarm': Number(clusterInputs[element].maxCurrent)
              }
            }
          }
        }
        if (element === 'output48one' && clusterSelected[element].kod === 'other') {
          arrayDevice[clusterSelected[element].kod + '48one'] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              },
              'total': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              }
            }
          }
        }
        if (element === 'output48two' && clusterSelected[element].kod === 'other') {
          arrayDevice[clusterSelected[element].kod + '48two'] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              },
              'total': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              }
            }
          }
        }
        if (element === 'output48three' && clusterSelected[element].kod === 'other') {
          arrayDevice[clusterSelected[element].kod + '48three'] = {
            'current': {
              'quantity': 1,
              'single': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              },
              'total': {
                'quiescent': Number(clusterInputs[element].currentMode) * 4,
                'alarm': Number(clusterInputs[element].currentAlarm) * 4
              }
            }
          }
        }
        if (element === 'callStation' && clusterSelected[element].hasOwnProperty('PRA-CSLD')) {
          arrayDevice[clusterSelected[element]['PRA-CSLD'].kod] = {
            'current': {
              'quantity': Number(clusterInputs[element].csDesktop),
              'single': {
                'quiescent': Number(clusterSelected[element]['PRA-CSLD'].current.quiescent),
                'alarm': Number(clusterSelected[element]['PRA-CSLD'].current.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].csDesktop) * Number(clusterSelected[element]['PRA-CSLD'].current.quiescent),
                'alarm': Number(clusterInputs[element].csDesktop) * Number(clusterSelected[element]['PRA-CSLD'].current.alarm)
              }
            }
          }
        }
        if (element === 'callStation' && clusterSelected[element].hasOwnProperty('PRA-CSLW')) {
          arrayDevice[clusterSelected[element]['PRA-CSLW'].kod] = {
            'current': {
              'quantity': Number(clusterInputs[element].csWall),
              'single': {
                'quiescent': Number(clusterSelected[element]['PRA-CSLW'].current.quiescent),
                'alarm': Number(clusterSelected[element]['PRA-CSLW'].current.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].csWall) * Number(clusterSelected[element]['PRA-CSLW'].current.quiescent),
                'alarm': Number(clusterInputs[element].csWall) * Number(clusterSelected[element]['PRA-CSLW'].current.alarm)
              }
            }
          }
        }
        if (element === 'callStation' && clusterSelected[element].hasOwnProperty('PRA-CSE')) {
          arrayDevice[clusterSelected[element]['PRA-CSE'].kod] = {
            'current': {
              'quantity': Number(clusterInputs[element].csExt),
              'single': {
                'quiescent': Number(clusterSelected[element]['PRA-CSE'].current.quiescent),
                'alarm': Number(clusterSelected[element]['PRA-CSE'].current.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].csExt) * Number(clusterSelected[element]['PRA-CSE'].current.quiescent),
                'alarm': Number(clusterInputs[element].csExt) * Number(clusterSelected[element]['PRA-CSE'].current.alarm)
              }
            },
            'poe': {
              'quantity': Number(clusterInputs[element].poePorts),
              'single': {
                'quiescent': Number(clusterSelected[element]['PRA-CSE'].poe.quiescent),
                'alarm': Number(clusterSelected[element]['PRA-CSE'].poe.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].poePorts) * Number(clusterSelected[element]['PRA-CSE'].poe.quiescent),
                'alarm': Number(clusterInputs[element].poePorts) * Number(clusterSelected[element]['PRA-CSE'].poe.alarm)
              }
            },
            'alarm': {
              'quantity': Number(clusterInputs[element].cstEmergency),
              'single': {
                'quiescent': Number(clusterSelected[element]['PRA-CSE'].alarm.quiescent),
                'alarm': Number(clusterSelected[element]['PRA-CSE'].alarm.alarm)
              },
              'total': {
                'quiescent': Number(clusterInputs[element].cstEmergency) * Number(clusterSelected[element]['PRA-CSE'].alarm.quiescent),
                'alarm': Number(clusterInputs[element].cstEmergency) * Number(clusterSelected[element]['PRA-CSE'].alarm.alarm)
              }
            }
          }
        }
      })
      return arrayDevice
    },
    // ===========================================================
    setTotalDevicesQuantity (devices) {
      let countDevice = 0
      let countDeviceWithout = 0
      for (var key in devices) {
        for (var key2 in devices[key]) {
          countDevice += devices[key][key2].quantity
        }
      }
      for (var withoutkey in devices) {
        if (withoutkey !== 'PRA-MPS3') {
          for (var withoutkey2 in devices[withoutkey]) {
            countDeviceWithout += devices[withoutkey][withoutkey2].quantity
          }
        }
      }
      return { 'all': countDevice, 'without': countDeviceWithout, 'selected': (countDevice - 1) }
    },
    setTotalDevicesCurrent (devices) {
      let countQuiescent = 0
      let countAlarm = 0
      for (var key in devices) {
        for (var key2 in devices[key]) {
          if (devices[key][key2].total) {
            countQuiescent += devices[key][key2].total.quiescent
            countAlarm += devices[key][key2].total.alarm
          }
        }
      }
      let countQuiescentWithout = 0
      let countAlarmWithout = 0
      for (var withoutkey in devices) {
        if (withoutkey !== 'PRA-MPS3') {
          for (var withoutkey2 in devices[withoutkey]) {
            if (devices[withoutkey][withoutkey2].total) {
              countQuiescentWithout += devices[withoutkey][withoutkey2].total.quiescent
              countAlarmWithout += devices[withoutkey][withoutkey2].total.alarm
            }
          }
        }
      }
      return { 'allQuiescent': countQuiescent, 'withoutQuiescent': countQuiescentWithout, 'allAlarm': countAlarm, 'withoutAlarm': countAlarmWithout }
    },
    setDevicesCapacity (devices) {
      var countQuiescent = 0
      var countAlarm = 0
      var countTotal = 0
      var countTotally = 0
      for (var key in devices) {
        if (key !== 'other24') {
          devices[key]['capacity'] = {
            'quiescent': this.setCapacityQuiescent(devices[key].current.total.quiescent),
            'alarm': this.setCapacityAlarm(devices[key].current.total.alarm),
            'total': this.setCapacityTotal(this.setCapacityQuiescent(devices[key].current.total.quiescent), this.setCapacityAlarm(devices[key].current.total.alarm)),
            'single': this.setCapacitySingle(devices[key].current.quantity, devices[key].current.single.alarm),
            'totally': this.setCapacityTotally(this.setCapacitySingle(devices[key].current.quantity, devices[key].current.single.alarm), devices[key].current.quantity, devices[key].current.total.alarm)
          }
          countQuiescent += Number(devices[key]['capacity'].quiescent)
          countAlarm += Number(devices[key]['capacity'].alarm)
          countTotal += Number(devices[key]['capacity'].total)
          countTotally += Number(devices[key]['capacity'].totally)
          for (var key2 in devices[key]) {
            if (key2 !== 'capacity' && key2 !== 'current' && key2 !== 'loudspeaker') {
              devices[key][key2]['capacity'] = {
                'quiescent': this.setCapacityQuiescent(devices[key][key2].total.quiescent),
                'alarm': this.setCapacityAlarm(devices[key][key2].total.alarm),
                'total': this.setCapacityTotal(this.setCapacityQuiescent(devices[key][key2].total.quiescent), this.setCapacityAlarm(devices[key][key2].total.alarm)),
                'single': (key !== 'PRA-AD604' && key !== 'PRA-AD608' && (key !== 'PRA-ES8P2S' && key2 !== 'poe')) ? this.setCapacitySingle(devices[key][key2].quantity, devices[key][key2].single.alarm) : null,
                'totally': (key !== 'PRA-AD604' && key !== 'PRA-AD608' && (key !== 'PRA-ES8P2S' && key2 !== 'poe')) ? this.setCapacityTotally(this.setCapacitySingle(devices[key][key2].quantity, devices[key][key2].single.alarm), devices[key][key2].quantity, devices[key][key2].total.alarm) : this.setCapacityTotally(null, devices[key][key2].quantity, devices[key][key2].total.alarm)
              }
              countQuiescent += Number(devices[key][key2]['capacity'].quiescent)
              countAlarm += Number(devices[key][key2]['capacity'].alarm)
              countTotal += Number(devices[key][key2]['capacity'].total)
              countTotally += Number(devices[key][key2]['capacity'].totally)
            }
          }
        }
      }
      return { 'quiescent': countQuiescent, 'alarm': countAlarm, 'total': countTotal, 'totally': countTotally }
    },
    setDevicesResults (capacity, totalCurrent) {
      var maxBatteryCurrent = (totalCurrent.allQuiescent > totalCurrent.allAlarm) ? (totalCurrent.allQuiescent / 1000) : (totalCurrent.allAlarm / 1000)
      var mainsCurrent115 = (capacity.totally / 1000) * 2
      var mainsCurrent230 = (capacity.totally / 1000)
      // eslint-disable-next-line no-tabs
      // var requiredBattery = (((this.config.SAFETY_FACTOR * capacity.total) / 100 + capacity.total) < 100) ? 100 : ((this.config.SAFETY_FACTOR * capacity.total) / 100 + capacity.total)
      var requiredBattery = ((this.config.SAFETY_FACTOR * capacity.total) / 100 + capacity.total)

      if (mainsCurrent115 === 0 && mainsCurrent230 === 0 && Math.ceil(maxBatteryCurrent) === 0) {
        requiredBattery = 0
      }
      return { 'mc115': mainsCurrent115, 'mc230': mainsCurrent230, 'maxBC': Math.ceil(maxBatteryCurrent), 'required': Math.ceil(requiredBattery) }
    },
    getTotalLoss (Clusters) {
      var powerIdle = 0
      var powerActive = 0
      var arrClusters = Clusters
      for (var key in arrClusters) {
        if (arrClusters[key]['PRA-AD604']) {
          powerIdle += arrClusters[key]['PRA-AD604'].current.quantity * 39
          powerActive += (((100 - 64) / 600) * arrClusters[key]['PRA-AD604'].loudspeaker.quantity) + (64 * arrClusters[key]['PRA-AD604'].current.quantity)
        }
        if (arrClusters[key]['PRA-AD608']) {
          powerIdle += arrClusters[key]['PRA-AD608'].current.quantity * 48
          powerActive += (((124 - 88) / 600) * arrClusters[key]['PRA-AD608'].loudspeaker.quantity) + (88 * arrClusters[key]['PRA-AD608'].current.quantity)
        }
      }
      var heatIdle = Math.ceil((powerIdle * 3600) / 1055)
      var heatActive = Math.ceil((powerActive * 3600) / 1055)
      this.changeValueOutputs('resultLoss', 'array',
        { 'powerIdle': powerIdle, 'powerActive': powerActive, 'heatIdle': heatIdle, 'heatActive': heatActive })
      return { 'powerIdle': powerIdle, 'powerActive': powerActive, 'heatIdle': heatIdle, 'heatActive': heatActive }
    },
    setQulityClusters (batteries) {
      var count = 0
      Object.values(batteries).filter(item => {
        if (item !== null) {
          count++
        }
      })
      this.changeValueOutputs('qtyClusters', 'value', count)
      return count
    },
    setListwy (qty) {
      if (this.inputs.przylacze_zasilania.active) {
        if (this.inputs.przylacze_zasilania.value === 1 || this.inputs.przylacze_zasilania.value === '1') {
          this.changeValuePrice('listwaZ', Number(this.getPriceDevice('LZ1F-PRA', 'listwaZ')))
          this.changeValuePrice('listwaD', Number(this.getPriceDevice('LD1F6G', 'listwaD')))
          this.changeValueWeight('listwaZ', Number(this.getWeightDevice('LZ1F-PRA')))
          this.changeValueWeight('listwaD', Number(this.getWeightDevice('LD1F6G')))
        } else if (this.inputs.przylacze_zasilania.value === 3 || this.inputs.przylacze_zasilania.value === '3') {
          this.changeValuePrice('listwaZ', Number(this.getPriceDevice('LZ3F-PRA', 'listwaZ')))
          this.changeValuePrice('listwaD', Number(this.getPriceDevice('LD3F9G', 'listwaD')))
          this.changeValueWeight('listwaZ', Number(this.getWeightDevice('LZ3F-PRA')))
          this.changeValueWeight('listwaD', Number(this.getWeightDevice('LD3F9G')))
        }
      } else {
        if (qty < 3) {
          this.changeValuePrice('listwaZ', Number(this.getPriceDevice('LZ1F-PRA', 'listwaZ')))
          this.changeValuePrice('listwaD', Number(this.getPriceDevice('LD1F6G', 'listwaD')))
          this.changeValueWeight('listwaZ', Number(this.getWeightDevice('LZ1F-PRA')))
          this.changeValueWeight('listwaD', Number(this.getWeightDevice('LD1F6G')))
          this.changeValueInputs('przylacze_zasilania', 'value', 1)
        } else if (qty > 2) {
          this.changeValuePrice('listwaZ', Number(this.getPriceDevice('LZ3F-PRA', 'listwaZ')))
          this.changeValuePrice('listwaD', Number(this.getPriceDevice('LD3F9G', 'listwaD')))
          this.changeValueWeight('listwaZ', Number(this.getWeightDevice('LZ3F-PRA')))
          this.changeValueWeight('listwaD', Number(this.getWeightDevice('LD3F9G')))
          this.changeValueInputs('przylacze_zasilania', 'value', 3)
        } else {
          this.changeValuePrice('listwaZ', 0)
          this.changeValuePrice('listwaD', 0)
        }
      }
    },
    checkBatteries (pojemnosc) {
      var matchBatteries = []
      if (pojemnosc > 0) {
        this.ListaAkumulatory.filter(item => {
          if (item.pojemnosc >= pojemnosc) {
            item.label = item.kod
            matchBatteries.push(item)
          }
        })
      }
      if (matchBatteries[0]) {
        return matchBatteries[0]
      } else {
        if (pojemnosc > 230) {
          this.$store.commit('app/SET_ERROR_INFO', ['brak_akumulatora', true])
          this.cofnijRuch()
        }
        return null
      }
    },
    checkBatteriesMore (pojemnosc) {
      var matchBatteries = []
      if (pojemnosc > 0) {
        this.ListaAkumulatory.filter(item => {
          if (item.pojemnosc >= pojemnosc) {
            item.label = item.kod
            matchBatteries.push(item)
          }
        })
      }
      if (matchBatteries.length) {
        return matchBatteries
      } else {
        return null
      }
    },
    getPriceDeviceStatic (szafa, akumulatory) {
      // console.log('getPriceDeviceStatic - szafa: ', szafa)
      // console.log('getPriceDeviceStatic - akumulatory: ', akumulatory)
      var cena = 0
      var cenaAkum = 0
      var cenaSzafa = 0

      this.changeValueInputs('glebokosc_szafy', 'value', szafa.attributes.glebokosc)

      if (Object.keys(akumulatory).length > 0) {
        for (var item in akumulatory) {
          if (akumulatory[item] !== null) {
            if (this.$store.state.app.activeBattery[item]) {
              cena += Number(akumulatory[item].cena)
              cenaAkum += Number(akumulatory[item].cena)
            }
          }
        }
      }
      cenaSzafa += Number(szafa.attributes.cena)
      cena += cenaSzafa
      return { 'szafa': cenaSzafa, 'akumulatory': cenaAkum, 'total': cena }
    },
    getPriceDevice (kod, klucz = null) {
      var cena = 0
      if (kod !== null) {
        var device = this.ListaPulsar.filter(item => item.kod === kod)
        if (device[0]) {
          // console.log('------ calculations.js -------')
          // console.log('------ getPriceDevice -------')
          // console.log(device[0])
          cena = device[0].attributes.cena
          if (klucz) {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': klucz, 'value': device[0]})
          }
        } else {
          cena = 0
          if (klucz) {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': klucz, 'value': []})
          }
        }
      }
      return cena
    },
    getWeightDeviceStatic (szafa, akumulatory) {
      // console.log(akumulatory)
      var waga = 0
      var wagaAkum = 0
      var wagaSzafa = 0
      if (Object.keys(akumulatory).length > 0) {
        for (var item in akumulatory) {
          if (akumulatory[item] !== null) {
            waga += Number(akumulatory[item].waga)
            wagaAkum += Number(akumulatory[item].waga)
          }
        }
      }
      wagaSzafa += Number(szafa.attributes.waga)
      waga += wagaSzafa
      return { 'szafa': wagaSzafa, 'akumulatory': wagaAkum, 'total': waga }
    },
    getWeightDevice (kod) {
      var waga = 0
      if (kod !== null) {
        var device = this.ListaPulsar.filter(item => item.kod === kod)
        if (device[0]) {
          waga = device[0].attributes.waga
        } else {
          waga = 0
        }
      }
      return waga
    },
    // ==========================================================
    getAttributesDevice (cluster) {
      var arr = []
      var device = []
      if (cluster !== undefined) {
        Object.keys(cluster).forEach(element => {
          if (cluster[element].selected && cluster[element].selected !== '-') {
            if (cluster[element].selected !== 'other') {
              device = this.ListaBosch.filter(item => item.kod === cluster[element].selected)
              arr[element] = device[0]
            } else {
              arr[element] = { 'kod': 'other', 'grupa': 'other', 'attributes': { 'wysokosc': cluster[element].countU } }
            }
          }
          if (element === 'callStation') {
            if (cluster[element].csDesktop > 0 || cluster[element].csWall > 0 || cluster[element].csExt > 0) {
              arr[element] = []
              if (cluster[element].csDesktop > 0) {
                device = this.ListaBosch.filter(item => item.kod === 'PRA-CSLD')
                arr[element][device[0].kod] = device[0]
              }
              if (cluster[element].csWall > 0) {
                device = this.ListaBosch.filter(item => item.kod === 'PRA-CSLW')
                arr[element][device[0].kod] = device[0]
              }
              if (cluster[element].csExt > 0) {
                device = this.ListaBosch.filter(item => item.kod === 'PRA-CSE')
                arr[element][device[0].kod] = device[0]
              }
            }
          }
          // koniec callStation
        })
      }
      return arr
    },
    getDevicesCurrent (clusterSelected, clusterInputs) {
      var quiescent = 0
      var alarm = 0
      Object.keys(clusterSelected).forEach(element => {
        quiescent += Number(clusterSelected[element]['current'].quiescent)
        alarm += Number(clusterSelected[element]['current'].alarm)
        Object.keys(clusterInputs[element]).forEach(item => {
          // powerSupply ethernet 1
          if (Number(clusterInputs[element][item]) > 0) {
            quiescent += Number(clusterInputs[element][item]) * Number(clusterSelected[element][item].quiescent)
            alarm += Number(clusterInputs[element][item]) * Number(clusterSelected[element][item].alarm)
          }
          // if (clusterSelected[element][item] && Number(clusterInputs[element][item]) > 0) {
          //   quiescent += Number(clusterInputs[element][item]) * Number(clusterSelected[element][item].quiescent)
          //   alarm += Number(clusterInputs[element][item]) * Number(clusterSelected[element][item].alarm)
          // } else {
          //   quiescent += Number(clusterInputs[element][item])
          //   alarm += Number(clusterInputs[element][item])
          // }
        })
      })
      return { 'quiescent': quiescent, 'alarm': alarm }
    },
    getDevicesQuantity (clusterSelected, clusterInputs) {
      var count = 0
      Object.keys(clusterSelected).forEach(element => {
        ++count
      })
      Object.keys(clusterInputs).forEach(element => {
        Object.values(clusterInputs[element]).forEach(item => {
          if (parseInt(item) > 0) {
            count += Number(item)
          }
        })
      })
      return count
    },
    getDevicesHeight (clusterSelected, batteriesSelected) {
      var wysokosc = 0
      var wysokoscOtw = 0
      Object.keys(clusterSelected).forEach(element => {
        if (Object.keys(clusterSelected[element]).length > 0) {
          Object.keys(clusterSelected[element]).forEach(item => {
            // console.log(clusterSelected[element][item])
            if (clusterSelected[element][item].attributes) {
              wysokosc += Number(clusterSelected[element][item].attributes.wysokosc)
              wysokoscOtw += Number(clusterSelected[element][item].attributes.wysokosc) * 3
            } else {
            }
          })
          ++wysokoscOtw
        }
      })
      // var bat = 0
      // for (var item in batteriesSelected) {
      //   if (batteriesSelected[item] !== null) {
      //     bat++
      //   }
      // }
      // var wysokoscAkumulatorow = Math.ceil(bat / 2) * 6
      // wysokosc akumulatorow
      var wysokoscAkumulatorow = batteriesSelected * 7// 6
      wysokosc += wysokoscAkumulatorow
      wysokoscOtw += wysokoscAkumulatorow * 3
      // console.log('wysokoscAkumulatorow',wysokoscAkumulatorow)
      // console.log('wysokoscAkumulatorow',(wysokoscAkumulatorow * 3))
      var panel = 1
      wysokosc += panel
      wysokoscOtw += panel * 3
      // console.log('panel',panel)
      // console.log('panel',(panel * 3))
      var listwa = 3
      wysokosc += listwa
      wysokoscOtw += listwa * 3
      // console.log('listwa',listwa)
      // console.log('listwa',(listwa * 3))
      return { 'wysokosc': wysokosc, 'oczka': wysokoscOtw }
    },
    getDevicesHeightPlus (zaslepka, mikrofon, dodatkoweMiejsce) {
      var wysokosc = 0
      var wysokoscOtw = 0
      if (zaslepka === 1 || zaslepka === '1') {
        wysokosc += 1
        wysokoscOtw += 1 * 3
      }
      if (mikrofon === 1 || mikrofon === '1') {
        wysokosc += 5
        wysokoscOtw += 5 * 3
      }
      if (Number(dodatkoweMiejsce) > 0) {
        wysokosc += Number(dodatkoweMiejsce)
        wysokoscOtw += Number(dodatkoweMiejsce * 3)
      }
      return { 'wysokosc': wysokosc, 'oczka': wysokoscOtw }
    },
    // changeDepthRack (szafa) {
    //   console.log(szafa)
    //   //       var matchSzafa = []
    //   // matchSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc >= szukanaWysokosc))
    //   // this.changeValueOutputs('szafa', 'array', matchSzafa[0])
    // },
    changeRackCabinets (wysokosc) {
      // console.log((50 * 3) - wysokosc)

      // if (this.inputs.panel_wentylacyjny.value === 1 || this.inputs.panel_wentylacyjny.value === '1') {
      //   var zaslepka = 3
      //   wysokosc = wysokosc + zaslepka
      // }

      if (((50 * 3) - wysokosc) < 3) {
        this.$store.commit('app/SET_ERROR_INFO', ['brak_miejsca', true])
      } else {
        this.$store.commit('app/SET_ERROR_INFO', ['brak_miejsca', false])
      }

      // console.log(this.inputs.glebokosc_szafy.value)
      // console.log(this.ListaSzafy)
      var matchSzafa = []
      // matchSzafa = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= wysokosc && Number(item.attributes.glebokosc) === Number(this.inputs.glebokosc_szafy.value)))
      matchSzafa = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= wysokosc))
      // console.log(matchSzafa)
      if (matchSzafa[0]) {
        this.changeValueOutputs('szafa', 'array', matchSzafa[0])

        var wysokoscSzafy = matchSzafa[0].attributes.wysokosc
        var wolneMiejsce = (wysokoscSzafy * 3) - wysokosc

        // console.log('wysokosc elementow', (wysokosc/3))
        // console.log('wysokoscSzafy', wysokoscSzafy)
        // console.log('wolneMiejsce', wolneMiejsce/3)
        // console.log('wysokosc elementow oczka', wysokosc)
        // console.log('wysokoscSzafy oczka', (wysokoscSzafy*3))
        // console.log('wolneMiejsce oczka', wolneMiejsce)

        this.changeValueOutputs('szafa_wolne_miejsce', 'value', Number(wolneMiejsce))
      } else {
        this.changeValueInputs('glebokosc_szafy', 'value', 800)

        // alert('Brak miejsca w szafie')
        this.$store.commit('app/SET_ERROR_INFO', ['brak_szafy', true])
        // this.cofnijRuch()
      }

      var aDepth = []
      for (var item in matchSzafa) {
        if (matchSzafa[item].attributes.wysokosc === wysokoscSzafy) {
          aDepth.push(matchSzafa[item].attributes.glebokosc)
        }
      }
      this.changeValueInputs('glebokosc', 'value', aDepth)
      if (aDepth.length === 1) {
        this.changeValueInputs('glebokosc_szafy', 'value', aDepth[0])
      }

      if (wysokoscSzafy > 24 && (this.inputs.panel_wentylacyjny.value === 0 || this.inputs.panel_wentylacyjny.value === '0')) {
        this.changeOther('panel_wentylacyjny', 1)
      }
    },
    setCapacityQuiescent (q) {
      // console.log(this.config.QUIESCENT_MODE)
      // console.log(this.inputs.czas_podtrzymania.value)
      // return ((q * this.config.QUIESCENT_MODE) / 1000)
      return ((q * Number(this.inputs.czas_podtrzymania.value)) / 1000)
    },
    setCapacityAlarm (a) {
      return ((a * this.config.EVACUATION_TIME) / 60000)
    },
    setCapacityTotal (q, a) {
      return (q + a)
    },
    setCapacitySingle (count, a) {
      return ((a) ? ((count > 0) ? (a * 12 / 0.9 / 230) : 0) : null)
    },
    setCapacityTotally (single, count, total) {
      if (single === null) {
        return Math.round(total * 12 / 0.9 / 230)
      }
      return Math.ceil((Number(single) * count))
    },
    configuration_keygen () {
      var numerSzafy = this.outputs.szafa.gen_code
      var numerGrupa1 = (this.outputs.akumulators.c1) ? this.outputs.akumulators.c1.gen_code : 0
      var numerGrupa2 = (this.outputs.akumulators.c2) ? this.outputs.akumulators.c2.gen_code : 0
      var numerGrupa3 = (this.outputs.akumulators.c3) ? this.outputs.akumulators.c3.gen_code : 0
      var numerGrupa4 = (this.outputs.akumulators.c4) ? this.outputs.akumulators.c4.gen_code : 0
      var numerGrupa5 = (this.outputs.akumulators.c5) ? this.outputs.akumulators.c5.gen_code : 0
      var numerGrupa6 = (this.outputs.akumulators.c6) ? this.outputs.akumulators.c6.gen_code : 0
      var numerLD = (this.outputs.qtyClusters.value > 2) ? 2 : 1
      var numerLZ = (this.outputs.qtyClusters.value > 2) ? 2 : 1

      if (this.inputs.przylacze_zasilania.active) {
        if (this.inputs['przylacze_zasilania'].value === 1) {
          numerLD = 1
          numerLZ = 1
        } else if (this.inputs['przylacze_zasilania'].value === 3) {
          numerLD = 2
          numerLZ = 2
        }
      } else {
        if (this.outputs.qtyClusters.value > 2) {
          numerLD = 2
          numerLZ = 2
        }
      }

      var numerSygnalizator = 1
      var numerWentylator = this.inputs.panel_wentylacyjny.value
      var numerMikrofon = this.inputs.polka_mikrofon.value
      var numerKolka = this.inputs.kolka.value
      var keyGen = 'DSO-PRA-'
      keyGen += numerSzafy
      keyGen += numerGrupa1 + '' + numerGrupa2 + '' + numerGrupa3 + '' + numerGrupa4 + '' + numerGrupa5 + '' + numerGrupa6
      keyGen += '/'
      keyGen += numerLD + '' + numerLZ
      keyGen += numerSygnalizator + '' + numerWentylator
      keyGen += numerMikrofon + '' + numerKolka
      this.changeValueOutputs('keyGen', 'value', keyGen)
    },
    cofnijRuch () {
      if (Object.keys(this.copyValues).length > 0) {
        let items = JSON.parse(this.copyValues)
        console.log(items)
        if (Object.keys(items).length > 0) {
          var keysList = ['config', 'inputs', 'outputs', 'clusterOne', 'clusterTwo', 'clusterThree', 'clusterFour', 'clusterFive', 'clusterSix']
          var count = 0
          Object.keys(items).forEach(element => {
            if (keysList.indexOf(element) > -1) {
              count++
            }
          })
          if (count === keysList.length) {
            // console.log('wczytanie kopi')
            this.$store.commit('app/UPDATE_DATA_FILE', items)
            this.$store.commit('app/UPDATE_VARIABLES', {'name': 'openFile', 'value': true})
            this.obliczenia_sprzetowe()
          } else {
          }
        }
      }
    },
    zapiszRuch () {
      // console.log('----- zapiszRuch -----')
      var json = {
        'config': this.config,
        'inputs': this.inputs,
        'outputs': this.outputs,
        'clusterOne': this.clusterOne,
        'clusterTwo': this.clusterTwo,
        'clusterThree': this.clusterThree,
        'clusterFour': this.clusterFour,
        'clusterFive': this.clusterFive,
        'clusterSix': this.clusterSix
      }
      const data = JSON.stringify(json)
      this.$store.commit('app/SET_COPY_VALUES', data)
    }
  }
}

// szafa_drzwi: { 'value': 1 }



// WEBPACK FOOTER //
// ./src/mixins/calculation.js